import { Injectable, NgZone } from "@angular/core";
import { AES_INFO, PATH_CODE, USER_INFO } from "src/app/shared/constants/common.const";
import { Util } from "src/app/shared/helpers/util";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  util = new Util();
  curUrl: string;

  constructor(
    private router: Router,
    private zone: NgZone,
  ) { }

  public hasPermission(currentUrl: string): boolean {
    let checkResult = false;
    const userMenus = this.util.getSecureStorage("MENU_RIGHT");
    const userInfo = this.util.getSecureStorage(USER_INFO.STORE);
    if (this.isTargetPath(currentUrl)) {
      if (userInfo.subIDYn === "N") {
        checkResult = true;
      } else {
        if (userMenus) {
          checkResult = userMenus.some((item) => (item?.level2MenuCode === PATH_CODE[currentUrl] || item?.levelMenuSub === PATH_CODE[currentUrl] && item?.menuUseRightTypeCode === "2"));
        } else {
          checkResult = false;
        }
      }
    } else {
      checkResult = true;
    }
    return checkResult;
  }

  private isTargetPath(currentUrl: string) {
    let checkResult = true;
    const nonPermissionMenu = ["main/home", "announce", "/main/setting/detail"];
    nonPermissionMenu.every((item, index) => {
      if (currentUrl.indexOf(item) !== -1) {
        checkResult = false;
        return false;
      } else {
        return true;
      }
    });
    return checkResult;
  }

  public hasSession(): boolean {
    return (!this.isEventTimeOver() && this.getUserInfo() !== null);
  }

  public getUserInfo(): any {
    return this.util.getSecureStorage(USER_INFO.STORE);
  }

  public getAesInfo(): any {
    return this.util.getSecureStorage(AES_INFO.STORE);
  }

  public logout() {
    this.util.removeSecureStorage(AES_INFO.STORE);
    this.util.removeSecureStorage(USER_INFO.STORE);
    this.util.removeSecureStorage("MENU_RIGHT");
    this.util.removeSecureStorage("FIRST_LOAD");
    this.util.removeSecureStorage("SEARCH_CONDITION");
    this.util.removeSecureStorage("SEARCHFAQ_CONDITION");
    this.util.removeSecureStorage("INQUIRY_CONDITION");
    $("kendo-dialog").remove();
    this.zone.run(() => this.router.navigate(["/login"]));
  }

  public setLastEventTime(): void {
    this.util.setSecureStorage("lastEventTime", String(new Date().getTime()));
  }

  public initLastEventTime(): void {
    this.util.setSecureStorage("lastEventTime", "-1");
  }

  public getLastEventTime(): number {
    const lastEventTime = Number(this.util.getSecureStorage("lastEventTime"));
    return (lastEventTime ? lastEventTime : -1);
  }

  public getEventTimeDiff(): number {
    const lastEventTime = Number(this.util.getSecureStorage("lastEventTime"));
    if (lastEventTime) {
      return (new Date().getTime() - lastEventTime);
    } else {
      throw new Error("'lastEventTime' is not defined.");
    }
  }

  public isEventTimeOver(time?: number): boolean {
    const util = new Util();
    const lastEventTime = Number(util.getSecureStorage("lastEventTime"));
    if (lastEventTime) {
      return (new Date().getTime() - lastEventTime >  (time || environment.autoLogoutTime));
    } else {
      return undefined;
    }
  }
}
